import React from "react";
import { iconCircle, methodContainer } from "./style.module.css";

export function OptionMaterial(props: {
  materialIcon: string;
  text: string;
  url: string;
  urlText: string;
}) {
  return (
    <div className={methodContainer}>
      <div className={iconCircle}>
        <span className="material-icons" style={{color:"#FFF"}}>{props.materialIcon}</span>
      </div>
      <p style={{ color: "#ECFF6A" }}>{props.text}</p>
      <a href={props.url} style={{ color: "black" }}>
        {props.urlText}
      </a>
    </div>
  );
}

export function OptionFontAwesome(props: {
  materialIcon: string;
  text: string;
  url: string;
  urlText: string;
}) {
  return (
    <div className={methodContainer}>
      <div className={iconCircle}>
        <span className="material-icons">{props.materialIcon}</span>
      </div>
      <p style={{ color: "#FE8115" }}>{props.text}</p>
      <a href={props.url} style={{ color: "#FFFFFF" }}>
        {props.urlText}
      </a>
    </div>
  );
}

export function Option(props: {
  fontClass: string;
  text: string;
  url: string;
  urlText: string;
}) {
  return (
    <div className={methodContainer}>
      <div className={iconCircle}>
        <i className={props.fontClass} style={{fontSize:"20pt", color: "#FFF"}}></i>
      </div>
      <p style={{ color: "#FE8115" }}>{props.text}</p>
      <a href={props.url} style={{ color: "#FFFFFF" }}>
        {props.urlText}
      </a>
    </div>
  );
}
